module.exports = __webpack_public_path__ + "static/media/vain-metting-2.9229c3bd.png";